import { useReduxState } from 'hooks';
import { Icon } from 'components/common/icons';

import type { IconProp } from 'components/common/icons/Icon';

interface Props {
  color?: string;
  icon?: IconProp;
  iconColor?: string;
  label: string;
  value: number | React.ReactNode;
}

const StatRow = ({ color, icon, iconColor, label, value }: Props) => {
  const { theme } = useReduxState();

  return (
    <div className="stat">
      <div className="row">
        <div className="col">
          <div className="label">
            {icon ? (
              <Icon
                icon={icon}
                fixedWidth={true}
                style={{
                  color: iconColor || 'inherit',
                  marginRight: 10,
                  marginTop: 2
                }}
              />
            ) : null}
            <span className="label-content">{label}</span>
          </div>
        </div>
        <div className="col-min">
          <span className="value">{value}</span>
        </div>
      </div>

      <style jsx>{`
        .stat {
          color: ${color || theme.textColorLighter};
          font-size: 1.3rem;
          font-weight: 600;
          padding: 10px 10px;
        }
        .stat:not(:first-child) {
          border-top: 1px solid ${theme.lightGrey};
        }
        .label {
          display: flex;
        }
        .value {
          color: ${color || theme.textColorLight};
          font-weight: 700;
        }
      `}</style>
    </div>
  );
};

export default StatRow;
